/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GoalsModel } from '../../models/goals-model';

export interface ProfileMemberGoalGet$Params {
}

export function profileMemberGoalGet(http: HttpClient, rootUrl: string, params?: ProfileMemberGoalGet$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<GoalsModel>> {
  const rb = new RequestBuilder(rootUrl, profileMemberGoalGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<GoalsModel>;
    })
  );
}

profileMemberGoalGet.PATH = '/Profile/MemberGoal';
